module.exports = "/build/web/svg/icon-check--green.b6be67158834e18fcc1d1191239e3725.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-check--green.svg
// module id = 124
// module chunks = 13